export default __webpack_public_path__ + "static/media/mont.0fba934a.png";